/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { IconColorful } from '@picsio/ui';
import './styles.scss';

const Selection = (props) => {
  const {
    icon,
    label,
    onChange,
    isSelected,
    disabled = false,
    className,
    description = null,
  } = props;
  const radioStyle = `Selection ${isSelected ? 'Selection--checked' : ''} ${disabled ? 'Selection--disabled' : ''}`;

  return (
    <div
      className={`${className} ${radioStyle}`}
      onClick={onChange}
    >
      <span className="Selection__input" />
      <If condition={icon}>
        <IconColorful size="xxxl">
          {icon}
        </IconColorful>
      </If>
      <div className="mainInfo">
        <If condition={label}>
          <span className="Selection__label">
            {label}
          </span>
        </If>
        <If condition={description}>
          <span className="Selection__description">
            {description}
          </span>
        </If>
      </div>
    </div>
  );
};

export default Selection;
